module.exports = "<my-steriles-edit-form my-steriles=\"$$sterile.data.mySteriles\"\n  my-wagon-id=\"$$wagon.local.getCurrentScrappedId()\">\n</my-steriles-edit-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/scrapping/sale/templates/editSteriles.html
// module id = 1625
// module chunks = 0